/**
 * Created by 212610877 on 5/29/2017.
 */
(function (global) {
  // var liveUpdate = true;  //read config file on the fly
  var configJSON;

  // all the views of the app
  var views = new Object();

  var ConfigMgr = {
    fetchConfig(next) {
      return getJSONConfigurationFile(next);
    },
    getConfig() {
      return configJSON;
    },
    getResourceFromArray(id, array) {
      const matchingIndex = getMatchingIdFromArraySources(id, array);
      if (matchingIndex >= 0) {
        return array[matchingIndex];
      }
      return null;
    },
    views : views,  // All the Views in the config file.
  };

  function getJSONConfigurationFile(next) {
    if (configJSON) { return; }

    // if (liveUpdate) {
      //jQuery.getJSON('./static/config.json', function (configFile) {
      jQuery.getJSON( window.configJSONPath, function (configFile) {
        console.log("Read configuration file ... ");
        if (configFile) {
          configJSON = configFile;
        }
        parseConfigFile();
        next();
      })
      .error(function () {
        console.error('APP DASH (Vuejs): config.json is not read.  Please ensure no comment block in JSON file and JSON is properly formatted.');
      });
  }

  // helper function to parse configuration file into Views map
  function parseConfigFile() {
    // debugger;
    for (var i = 0; i < configJSON.views.length; i++) {
      var curr = configJSON.views[i];
      views[curr.name] = curr;
    }
  }

  function getMatchingIdFromArraySources(id, sources) {
    for (const index in sources) {
      // debugger;
      if (sources[index].id === id) {
        return index;
      }
    }
    return -1;
  }

  if (typeof exports === 'object') {
    module.exports = ConfigMgr;
  } else if (typeof define === 'function' && define.amd) {
    define(function () {
      return ConfigMgr;
    });
  } else {
    global.ConfigMgr = ConfigMgr;
  }
}(this));



// WEBPACK FOOTER //
// ./src/assets/js/configMgr.js